/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  deleteSenderAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/sender_avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  sendTelegramTestMessage(inboxId, botToken) {
    return axios.post('/api/v1/gamefire_telegram/test_notification', {
      chat_id: parseFloat(inboxId),
      token: botToken
    });
  }

  translateText(inboxId, text, targetLanguages) {
    return axios.post(`${this.url}/${inboxId}/translate_text`, {
      text,
      target_languages: targetLanguages,
    });
  }

  getPlatformCurrencyList(inboxId) {
    return axios.get(`${this.url}/${inboxId}/platform_currency_list`);
  }
}

export default new Inboxes();
